import cn from 'classnames';
import { useIntl } from 'react-intl';
import { useFeesBySolutionContext } from 'sonata-platform-components';
import { Card, Loader, Toast } from 'sonata-react-components';

import { StepOneStyled } from './stepOne.styled';

const MEDIA_CHANNEL_ICONS: Record<string, string> = {
  ctv: 'fa-solid fa-screencast',
  dooh: 'fa-kit fa-screen',
  standard: 'fa-solid fa-laptop-mobile'
};

function StepOne() {
  const { formatMessage } = useIntl();
  const { campaign, getStep1, handleStep1Change, mediaChannelsTypes, mode, solutionsAndPlansDataIsLoading } =
    useFeesBySolutionContext();

  const { type: selectedMediaChannel } = getStep1();
  const isDisabled = mode === 'edit' || !!campaign.insertionOrder;

  return (
    <StepOneStyled className="feesBySolutionStepOne" data-testid={'feesBySolutionStepOne'}>
      {solutionsAndPlansDataIsLoading && <Loader showBackground type="landing" variant="default" />}
      <Toast
        autoClose={false}
        className="dynamicBidPrice__toast"
        closeButton={false}
        icon="fal fa-info-circle"
        text={formatMessage({
          defaultMessage: 'This media channel is automatically inherited from your selected Insertion Order.',
          id: 'campaign.budgetAndPricing.dynamicBidPrice.error.message'
        })}
        type="info"
      />
      <div className="feesBySolutionStepOne__cardContainer">
        {mediaChannelsTypes.map((mediaChannel: string) => {
          const isSelected = mediaChannel === selectedMediaChannel;
          return (
            <Card
              className={cn('feesBySolutionStepOne__card', { 'feesBySolutionStepOne__card--disabled': isDisabled })}
              isSelected={isSelected}
              key={mediaChannel}
              onClick={() => {
                if (!isDisabled) {
                  handleStep1Change(mediaChannel);
                }
              }}
            >
              <Card.Media
                className={cn('feesBySolutionStepOne__cardMedia', {
                  'feesBySolutionStepOne__cardMedia--selected': isSelected
                })}
                icon={MEDIA_CHANNEL_ICONS[mediaChannel] ?? 'fa-solid fa-laptop-mobile'}
              />
              <Card.Body align="center">
                <Card.Label variant="title">
                  {formatMessage({ id: `feesBySolution.campaign.${mediaChannel}` })}
                </Card.Label>
                <Card.Label ellipsis={false} variant="subtitle">
                  {formatMessage({
                    defaultMessage: `${mediaChannel} description`,
                    id: `feesBySolution.stepOne.${mediaChannel}Description1`
                  })}
                </Card.Label>
                <Card.Label className="feesBySolutionStepOne__cardSubtext" ellipsis={false} variant="subtitle">
                  {formatMessage({
                    defaultMessage: `${mediaChannel} available ad  formats`,
                    id: `feesBySolution.stepOne.${mediaChannel}Description2`
                  })}
                </Card.Label>
              </Card.Body>
            </Card>
          );
        })}
      </div>
    </StepOneStyled>
  );
}

export default StepOne;
